export default __webpack_public_path__ + "static/media/misc-pantry3-1920w.abc605a9.avif";